import { render, staticRenderFns } from "./SchoolRecipient.vue?vue&type=template&id=174c0b9d&"
import script from "./SchoolRecipient.vue?vue&type=script&lang=js&"
export * from "./SchoolRecipient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports